import React from 'react';

const DaySvg = (props) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" className={props.clazz || ""}>
          <g fill={props.fill || ""} fillRule="evenodd">
            <path d="M11.7 10.4H9.85a.52.52 0 0 1-.52-.52V8.02a.52.52 0 0 1 1.04 0v1.34h1.35a.52.52 0 1 1 0 1.04" />
            <g transform="translate(0 -.24)">
              <path d="M9.85 1.33a8.81 8.81 0 0 0-8.81 8.8 8.81 8.81 0 0 0 17.63 0c0-4.86-3.96-8.8-8.82-8.8m0 18.62A9.85 9.85 0 0 1 0 10.12a9.85 9.85 0 0 1 19.7 0 9.85 9.85 0 0 1-9.85 9.83" fill="#000000" mask="url(#b)"/>
            </g>
            <path d="M9.85 2.95A6.95 6.95 0 0 0 2.9 9.88a6.95 6.95 0 0 0 13.9 0 6.95 6.95 0 0 0-6.95-6.93m0 14.9a7.98 7.98 0 0 1-7.98-7.97 7.98 7.98 0 0 1 15.97 0c0 4.39-3.58 7.96-7.99 7.96" fill="#000000"/>
            <path d="M9.72 4.83a.52.52 0 0 1-.52-.51V2.46a.52.52 0 0 1 1.04 0v1.86c0 .28-.24.51-.52.51M4.28 10.26H2.4a.52.52 0 1 1 0-1.03h1.87a.52.52 0 1 1 0 1.03M9.72 17.55a.52.52 0 0 1-.52-.52v-1.86a.52.52 0 0 1 1.04 0v1.86c0 .29-.24.52-.52.52M17.02 10.26h-1.86a.52.52 0 1 1 0-1.03h1.86a.52.52 0 1 1 0 1.03" fill="#000000"/>
          </g>
        </svg>
    )
}

export default React.memo(DaySvg);